"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = () => {
    const theme = (0, material_1.useTheme)();
    const checkContainer = {
        background: theme.qlub.palette.iris.main,
        width: '24px',
        height: '24px',
        '&:active': {
            background: theme.qlub.palette.iris.main,
        },
        '&:hover': {
            background: theme.qlub.palette.iris.main,
        },
    };
    const circleContainer = {
        width: '24px',
        height: '24px',
        padding: '0px',
    };
    const checkIcon = {
        color: theme.qlub.palette.white.main,
    };
    const circleIcon = {
        color: theme.qlub.palette.dim.main,
    };
    return {
        checkContainer,
        circleContainer,
        checkIcon,
        circleIcon,
    };
};
exports.default = useStyle;
